// extracted by mini-css-extract-plugin
export default {"emailLink_medium":"EmailHeader_emailLink_medium__eHMBg","emailLink_small":"EmailHeader_emailLink_small__2p0C9","emailLink_large":"EmailHeader_emailLink_large__CjjsR"};